<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'PageLayout',
})
</script>
<template>
  <a-layout id="pages" :class="[device,theme]">
   <a-layout-header class="box-shadow">
    <pageheader :siteinfo="siteinfo"></pageheader>
   </a-layout-header>
    <a-layout-content>
       <RouterView />
    </a-layout-content>
      <a-layout-footer class="bg-black">
          <pagefooter :siteinfo="siteinfo"></pagefooter>
      </a-layout-footer>
  </a-layout>
</template>

<script lang="ts" setup name="PageLayout">
import { onMounted, ref,resolveComponent } from 'vue';
import { useRoute } from 'vue-router';
import api from '@/utils/http/service';
import {addip} from '@/utils/util'
import { onBeforeMount } from 'vue';
import useSiteSettings from '@/store/useSiteSettings'
const {  device,navTheme } = useSiteSettings()
  const route = useRoute();
  const pageData=ref<Object>({})
  const siteinfo=ref<Object>()
  const theme=ref<String>(navTheme)
  onMounted(()=>{
     api.global.siteinfo().then(res=>{
        siteinfo.value=res.data
        document.title=res.data.title
      })
  })

</script>
<style lang="less">
@import '@/style/style.less';
</style>
